import React, { useEffect, useRef, useState } from "react";
import style from "../../soloJourney/solo.module.sass"
import close from "../../../../../assets/svg/solo/editorMax.svg"
import Editor from "@monaco-editor/react";
import { Button } from "antd";
import { generateTypeDefs } from '../../../../../helpers/typedefinitions'
import _ from "lodash";
import { initializeA8FormsTypeDefs } from "../../../../../helpers/typedefinitions/a8forms";

const Popup = (props: any) => {
    const defaultCodeEditorValue =
        `async function main() {
    // Start of editable area 
    
    // End of editable area
}`
    const monacoRef: any = useRef(null)
    const [values, setValues] = useState(props.type ? defaultCodeEditorValue : "")
    const [jsonValues, setJsonValues] = useState("")
    const additionalOptions = {
        overviewRulerLanes: 0,
        overviewRulerBorder: false
    }
    const instanceRef: any = useRef(null);
    const editorRef: any = instanceRef;

    useEffect(() => {
        initializeA8FormsTypeDefs()
        if (props.values) {
            try {
                if (JSON.parse(props.values)) {
                    setJsonValues(JSON.parse(props.values))
                }
            } catch {
                setValues(props.values)
            }
        }
    }, [props.values])

    const startPhrase = "// Start of editable area";
    const endPhrase = "// End of editable area";

    const editableArea = (() => {
        return {
            includes: function (changes: any, model: any) {
                const fullRange = model.getFullModelRange();
                let { range: startRange } = model.findMatches(startPhrase, fullRange).shift() || {};
                let { range: endRange } = model.findMatches(endPhrase, fullRange).pop() || {};
                const { startLineNumber, endLineNumber, startColumn, endColumn } = fullRange;
                if (startRange && endRange) {
                    startRange = startRange.setStartPosition(startLineNumber, startColumn);
                    endRange = endRange.setEndPosition(endLineNumber, endColumn);
                    endRange = endRange.setStartPosition(endRange.startLineNumber, 1);
                    return changes.every(({ range, forceMoveMarkers }: any,) => {
                        //forceMoveMarkers will be true when formatting happens
                        return (forceMoveMarkers || ((range.startLineNumber > startRange.endLineNumber) && (range.startLineNumber < endRange.startLineNumber)))
                    });
                }
                return false;
            },
        };
    })();

    function beforeMount(monacoInstance: any) {
        monacoRef.current = monacoInstance
        monacoInstance.languages.typescript.javascriptDefaults.setDiagnosticsOptions({
            noSemanticValidation: false,
            noSyntaxValidation: false,
            noSuggestionDiagnostics: false,
        });
        const options = {
            lib: ['esnext'],
            target: monacoInstance.languages.typescript.ScriptTarget.ES2016,
            allowNonTsExtensions: true,
            noImplicitAny: false,
            noUnusedParameters: false,
            // noLib: true
        };
        if (props.type === 'inline' || props.type === 'functionClient' || props.typr === "solo") {
            options.lib.push('dom')
        }
        // compiler options
        monacoInstance.languages.typescript.javascriptDefaults.setCompilerOptions(options);
        monacoInstance.languages.typescript.typescriptDefaults.setCompilerOptions(options);
        // extra libraries
        var libSource = [];

        // Getting dynamic function typedefs here
        if (props.customdef) {
            libSource.push(props.customdef);
        }

        // Generate static typedefs
        let typedefs = ""
        if (props.type) {
            typedefs = generateTypeDefs(props.type)
        }
        libSource.push(typedefs)
        var libUri = "ts:customdefination/index.d.ts";
        monacoInstance.languages.typescript.javascriptDefaults.addExtraLib(libSource.join("\n"), libUri);
        const model = monacoInstance.editor.getModels();
        const find = _.find(model, (o) => {
            return o.getModeId() === "typescript";
        });
        if (!find) {
            monacoInstance.editor.createModel(libSource.join("\n"), "typescript", monacoInstance.Uri.parse(libUri));
        } else {
            monacoInstance.languages.typescript.typescriptDefaults.addExtraLib(libSource.join("\n"), libUri);
        }
    }


    function handleEditorDidMount(editor: any) {
        editorRef.current = editor;
        const editorModel = editor.getModel();

        editorModel.onDidChangeContentFast(({ changes, isUndoing }: { changes: any; isUndoing: any }) => {
            if (!isUndoing) {
                if (!editableArea.includes(changes, editorModel)) {
                    /*
                     * This Promise.resolve() sends the code to the micro task queue
                     * And it gets called before the event queue ( micro task queue has more priority than event queue)
                     * Thus, Promise.resolve() will be better than a setTimeout(fn,0) here
                     * If we do it synchronously, it affects some of monaco editor's functions
                     */
                    Promise.resolve().then(() => editor.trigger("someIdString", "undo"));
                }
            }
        });
    }

    return (
        <div className={style.popupbox} data-message-node={props.isMessageNode}>
            <div className={style.box}
                key={props.id}
            >
                <div style={{ overflow: "hidden" }}>
                    <div className={style.editorHeader}>
                        <div style={{ display: "flex", padding: 15 }}>
                            <img src={close} alt="close-editor"
                                style={{ height: "20px", cursor: "pointer" }}
                                onClick={props.close}
                            />
                        </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <Editor
                            height={"62vh"}
                            //defaultLanguage="javascript"
                            language={props.lang || "javascript"}
                            defaultValue={props.type ? values || defaultCodeEditorValue : jsonValues.length === 0 ? values.length === 0 ? "//editable area" : values : JSON.stringify(jsonValues, null, 2)}
                            theme="vs-dark"
                            options={{
                                quickSuggestions: {
                                    "other": props.type ? true : false,
                                    "comments":  props.type ? true : false,
                                    "strings":  props.type ? true : false
                                },
                                parameterHints: {
                                    enabled: props.type ? true : false
                                },
                                suggestOnTriggerCharacters: props.type ? true : false,
                                acceptSuggestionOnEnter: "on",
                                tabCompletion: "on",
                                wordBasedSuggestions: true,
                                selectOnLineNumbers: true,
                                roundedSelection: false,
                                cursorStyle: 'line',
                                minimap: {
                                    enabled: false
                                },
                                ...additionalOptions
                            }}
                            keepCurrentModel={false}
                            beforeMount={beforeMount}
                            onMount={props.type && handleEditorDidMount}
                            onChange={(e: any) => {setValues(e); setJsonValues(e)}}
                        />

                        <div style={{ display: "flex", justifyContent: "flex-end", marginRight: 5, padding: "10px" }}>
                            <Button
                                className={style.editorCloseButton}
                                onClick={props.close}
                            >Cancel </Button>
                            <Button
                                className={style.editorSaveButton}
                                onClick={() => { props.handleExpression(props.id, values || JSON.stringify(jsonValues)); props.close(); }}
                                type="primary"
                            >Save</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Popup;